import config from 'services/table/const';
import { formatDate } from 'utilities/common';
import Action from './table.action';

let table = { ...config };

table.url = '/marketing/quotation';
table.filter = {'document_status': 'published'}
table.columns = {
  code: {
    title: '# Code',
    sortable: true,
    width: 100,
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fs-8 fw-semibold text-uppercase">
            {row?.code}
          </div>
          <small className="info">
            {formatDate(row?.created_at, 'DD/MM/YYYY') || '-'}
          </small>
        </div>
      );
    },
  },

  customer_id: {
    title: 'Client',
    alias: 'customer.id',
    sortable: true,
    width: 250,
    class: '',
    component: (row) => {
      return (
        <div className="table-col">
          <div className="text-ellipsis fw-semibold text-uppercase">
            {row?.customer?.name}
          </div>
          <small className="info text-uppercase">
            {row?.customer?.company_name}
          </small>
        </div>
      );
    },
  },

  document_status: {
    title: 'Status',
    sortable: true,
    class: 'text-center',
    classHeader: 'text-center',
    width: 100,
    component: (row) => {
      return (
        <span className={`badge status-published-lt ms-auto `}>
          {row?.document_status?.replace('_', ' ')}
        </span>
      );
    },
  },

  action: {
    title: '',
    sortable: false,
    width: 50,
    class: 'text-end',
    component: (row) => {
      return <Action data={row} />;
    },
  },
};

export default table;
